import {
  INTERVENTIONS_FILTER_UPDATED,
  INTERVENTIONS_LOADED,
  INTERVENTIONS_NEED_FILTER,
} from '../constants/AppConstants';
import { SortDirections } from '../utils/sorting';

const initialState = {
  list: [],
  needsFilter: false,
  pagination: {
    currentPage: 0,
    numberOfPages: 0,
    pageSize: 10,
    totalElements: 0,
    sort: null,
    filter: {},
  },
};

/**
 * Manage only one level of sort.
 *
 * @param sort
 */
const getSort = (sort) =>
  sort
    ? {
        field: sort[0].property,
        direction: sort[0].direction === 'ASC' ? SortDirections.asc : SortDirections.desc,
      }
    : {};

export default function (state = initialState, action) {
  Object.freeze(state);
  switch (action.type) {
    case INTERVENTIONS_FILTER_UPDATED:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          pageSize: action.pageSize || 10,
          filter: action.filter,
        },
      };
    case INTERVENTIONS_LOADED:
      return {
        ...state,
        needsFilter: false,
        list: action.page.content,
        pagination: {
          ...state.pagination,
          currentPage: action.page.number,
          numberOfPages: action.page.totalPages,
          sort: getSort(action.page.sort),
          totalElements: action.page.totalElements,
        },
      };
    case INTERVENTIONS_NEED_FILTER:
      return {
        ...state,
        needsFilter: true,
      };
    default:
      return state;
  }
}
